<template>
  <collapsed-section :title="petDetailsHeaderTitle" :open="true">
    <error-banner v-if="error" :message="error"/>
    <labeled-form-control label="Name">
      <input v-model="name" class="form-control" type="text" value="Pet Name" :disabled="updated"/>
      <validation-message v-if="petValidator.name" :message="petValidator.name"/>
    </labeled-form-control>
    <pet-breed v-model="breedId" :validator="petValidator" :disabled="updated"/>
    <pet-dob v-model="dateOfBirth" :disabled="updated"/>
    <pet-gender v-model="genderId" :disabled="updated"/>
    <pet-neutered v-model="neuteredId" :disabled="updated"/>
    <pet-medical-note :pet-index="this.petIndex" :disabled="updated"/>
  </collapsed-section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { PetUpdateMixin } from '@/mixins/Registration/PetUpdateMixin'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import CollapsedSection from '@/components/Layout/CollapsedSection.vue'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'
import PetBreed from './PetBreed.vue'
import PetDob from './PetDob.vue'
import PetGender from './PetGender.vue'
import PetNeutered from './PetNeutered.vue'
import PetMedicalNote from './PetMedicalNote.vue'

export default {
  name: 'PetDetailsSection',
  mixins: [PetUpdateMixin, ClientOnboardingInviteCacheMixin],
  data () {
    return {
      updated: false
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    ...mapState('ApplicationEvents', [
      'updatePetDetailEvent'
    ]),
    petDetailsHeaderTitle () {
      return this.sectionName + "'s Details"
    }
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    updatePetDetailEvent () {
      this.handleUpdateEvent()
    },
    clientNoteUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setUpdatedPet'
    ]),
    ...mapMutations('ApplicationEvents', [
      'triggerUpdatePetDetail'
    ]),
    afterUpdatePet () {
      this.setUpdatedPet(this.petId)
      this.triggerUpdatePetDetail()
      this.updated = true
    },
    handleUpdateEvent () {
      if (this.clientNoteUpdated) {
        if (!this.updated && this.petIndex === this.updatePetDetailEvent) {
          this.tryUpdatePet()
        } else if (this.petIndex === this.updatePetDetailEvent) {
          this.triggerUpdatePetDetail()
        }
      }
    }
  },
  created () {
    this.updated = this.updatedPets.length > 0 ? this.updatedPets.includes(this.petId) : false
  },
  components: {
    'collapsed-section': CollapsedSection,
    'labeled-form-control': LabeledFormControl,
    'pet-breed': PetBreed,
    'pet-dob': PetDob,
    'pet-gender': PetGender,
    'pet-neutered': PetNeutered,
    'pet-medical-note': PetMedicalNote,
    'validation-message': ValidationMessage,
    'error-banner': ErrorBanner
  }
}
</script>
